import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Transition } from '@headlessui/react';

import '../assets/css/index.css';


export default function NavBar(props) {
    const [mobileMenuOn, setMobileMenuOn] = useState(false);
    return(
    <>
        <div>
            <nav className="bg-gray-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center">
                            <Link to='/' className="flex-shrink-0">
                                <span className="text-white">NFTree</span>
                            </Link>
                            <div className="hidden md:block">
                                <div className="ml-10 flex items-baseline space-x-4">
                                    <Link to="/" className={`${ props.history.location.pathname === '/' ? 'bg-gray-900' : 'hover:bg-gray-700 hover:text-white'} text-white px-3 py-2 rounded-md text-sm font-medium`}>Token List</Link>
                                    <Link to="/register-nft" className={`${ props.history.location.pathname === '/register-nft' ? 'bg-gray-900' : 'hover:bg-gray-700 hover:text-white'} text-gray-300  px-3 py-2 rounded-md text-sm font-medium`}>Register Token</Link>
                                </div>
                            </div>
                        </div>
                        <div className="-mr-2 flex md:hidden">
                            <button 
                                className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                                onClick={() => mobileMenuOn ? setMobileMenuOn(false) : setMobileMenuOn(true)}
                            >
                                <span className="sr-only">Open main menu</span>
                                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                                <svg className="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <Transition
                    show={ mobileMenuOn }
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <div className={ mobileMenuOn ? "block md:hidden" : "hidden md:hidden"}>
                        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                            <Link to="/" className={`${ props.history.location.pathname === '/' ? 'bg-gray-900' : 'hover:bg-gray-700 hover:text-white'} text-white block px-3 py-2 rounded-md text-base font-medium`}>Token List</Link>
                            <Link to="/register-nft" className={`${ props.history.location.pathname === '/register-nft' ? 'bg-gray-900' : 'hover:bg-gray-700 hover:text-white'} text-white block px-3 py-2 rounded-md text-base font-medium`}>Register Token</Link>
                        </div>
                    </div>
                </Transition>
            </nav>       
        </div>
    </>
    );
}
